import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faLightbulb, faStar, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const AssistantManagerHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faUserTie} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Assistant Manager</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>Your Assistant Manager provides tactical advice and weekly briefings. Higher levels = more accurate recommendations.</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faStar} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Manager Levels & Accuracy</h3>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 1: Aspiring Tactician</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Weekly Cost: £3,000 | Accuracy: 60%</div>
                    <div style={{ marginTop: '4px' }}>Learning the ropes. Basic tactical insights.</div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 2: Experienced Coach</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £600,000 | Weekly Cost: £12,000 | Accuracy: 70%</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Solid tactical understanding
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 3: Seasoned Strategist</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £2,000,000 | Weekly Cost: £35,000 | Accuracy: 80%</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Reliable matchup analysis
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Good transfer recommendations
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 4: Elite Tactician</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £6,000,000 | Weekly Cost: £80,000 | Accuracy: 90%</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Excellent tactical insights
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Accurate squad analysis
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 5: World Class Manager</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £15,000,000 | Weekly Cost: £200,000 | Accuracy: 95%</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Strategic masterminds insights
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Best transfer opportunities identified
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px' }}>
                <strong>Level 6: Legendary Strategic Mind</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Weekly Cost: £400,000 | Accuracy: 100%</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Perfect tactical recommendations
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Infallible briefings and analysis
                    </div>
                </div>
            </div>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />What Your Assistant Manager Does</h3>
            <div style={{ backgroundColor: 'rgba(0, 255, 155, 0.1)', padding: '12px', borderRadius: '4px', marginBottom: '16px' }}>
                <ul style={{ margin: '0', paddingLeft: '20px', lineHeight: '1.8' }}>
                    <li><strong>Weekly Briefings:</strong> Analysis of your squad and upcoming opponents</li>
                    <li><strong>Auto-Setup:</strong> One-click tactical recommendations for your next match</li>
                    <li><strong>Transfer Suggestions:</strong> Identify players to buy or sell based on formation</li>
                    <li><strong>Squad Analysis:</strong> Detailed player performance and role suitability</li>
                </ul>
            </div>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Cost-Benefit Strategy</h3>
            <div style={{ backgroundColor: 'rgba(0, 255, 155, 0.1)', padding: '12px', borderRadius: '4px' }}>
                <ul style={{ margin: '0', paddingLeft: '20px', lineHeight: '1.8' }}>
                    <li><strong>Early Game:</strong> Level 2-3 gives good value for modest investment.</li>
                    <li><strong>Critical Moments:</strong> Upgrade to Level 4+ when chasing promotion.</li>
                    <li><strong>Budget Crunch:</strong> Downgrade if needed - you lose tactical insights but save weekly wages.</li>
                    <li><strong>Quality Over Cost:</strong> Higher accuracy = better tactical decisions = more wins. Often worth the investment!</li>
                    <li><strong>Synergy:</strong> Works best with higher training facilities for optimal squad development.</li>
                </ul>
            </div>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
